import React from "react"
import { Button, Card, Modal, ModalBody, ModalHeader } from "reactstrap"
import PropTypes from "prop-types"
import { t } from "i18next"
import { useForm } from "react-hook-form"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { uploadDocument } from "api/docApi"
import LoadingButton from "components/Common/LoadingButton"
import DropzoneRHF from "components/RHF/DropzoneRHF"
import { toast } from "react-toastify"
import useFetchOptions from "hooks/useFetchOptions"
import PreviewFiles from "components/Common/PreviewFileCard"
import { formatBytes } from "helpers/utils"
import PreviewFileCard from "components/Common/PreviewFileCard"

function UploadDocumentModal(props) {
  const { isOpen, toggle, ...otherProps } = props
  const queryClient = useQueryClient()

  const { handleSubmit, control, watch, setValue, reset } = useForm({
    defaultValues: {
      upload_file: [],
    },
  })
  const filesWatch = watch("upload_file")

  const { mutate, isPending } = useMutation({
    mutationFn: values => {
      return uploadDocument(values)
    },
    onSuccess: () => {
      queryClient.invalidateQueries("folders")
      reset()
      toggle()
    },
    onError: error => toast.error(error),
  })

  const deleteFile = fileName => {
    setValue(
      "upload_file",
      filesWatch.filter(file => file.name !== fileName)
    )
  }

  return (
    <Modal centered isOpen={isOpen} toggle={toggle} {...otherProps}>
      <ModalHeader toggle={toggle}>{t("Import Documents")}</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit(mutate)} id="form_id">
          <DropzoneRHF
            name="upload_file"
            control={control}
            accept={{
              "image/*": [".png", ".pdf", ".jpeg", ".jpg"],
            }}
          />
          <div
            className="dropzone-previews max-h-sm overflow-auto  mt-3"
            id="file-previews"
          >
            {filesWatch.map((file, idx) => {
              return (
                <PreviewFileCard
                  file={file}
                  onDelete={() => deleteFile(file.name)}
                  key={file.name}
                />
              )
            })}
          </div>

          <LoadingButton
            className="mt-3"
            isLoading={isPending}
            type="submit"
            color="primary"
            form="form_id"
            block
          >
            {t("upload")}
          </LoadingButton>
        </form>
      </ModalBody>
    </Modal>
  )
}

UploadDocumentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
export default UploadDocumentModal
